import _ from 'underscore';
import { getSortedTaxFormMapping } from './taxform-store';
import { EmptyTaxForm } from './taxforms/empty-taxform';
import { EmptyViewTaxForm } from './taxforms/viewtaxforms/empty-viewtaxform';

const importAll = r => r.keys().forEach(r);

importAll(require.context('./taxforms/', true, /\.jsx$/));
importAll(require.context('./taxforms/viewtaxforms/', true, /\.jsx$/));

export const getMatchedTaxFormMappingItem = path => (path && _.find(getSortedTaxFormMapping(), mapItem => mapItem.matcher({ mapItem, path }))) || {};

export const getTaxForm = path => getMatchedTaxFormMappingItem(path).taxForm || EmptyTaxForm;

export const getViewTaxForm = path => getMatchedTaxFormMappingItem(path).viewTaxForm || EmptyViewTaxForm;
